import React from 'react';
import MUIDanger from '@mui/icons-material/Dangerous';
import { SvgIconProps } from '@mui/material/SvgIcon';

const DangerIcon = ({
  color = 'primary',
  ...rest
}: SvgIconProps) => (
  <MUIDanger
    color={color}
    {...rest}
  />
);

export default DangerIcon;
